import { runDemo } from "../shared/demoRunner";
import { createMultimaterialScene } from "./scene";

runDemo({ createScene: createMultimaterialScene });
